import * as actions from './actionTypes';

export enum ApiStatusEnum {
    Idle = "idle",
    Loading = "loading",
    Success = "success",
    Info = "info",
    Error = "error"
}

export interface IApiStore {
    status: ApiStatusEnum,
    message?: string,
    error?: string
}

export const INITIAL_STATE:IApiStore = {
    status: ApiStatusEnum.Idle,
    message: undefined,
    error: undefined
}

const ApiData = (state = INITIAL_STATE, action:{type: string, payload:any}) => {
    switch (action.type) {

        case actions.API_LOADING:
            state = {
                ...state,
                status: ApiStatusEnum.Loading,
                message: action.payload || "Loading"
            }
            break;

        case actions.API_SUCCESS:
            state = {
                ...state,
                status: ApiStatusEnum.Success,
                message: action.payload,
            }
            break;

        case actions.API_INFO:
            state = {
                ...state,
                status: ApiStatusEnum.Info,
                message: action.payload,
            }
            break;
            
        case actions.API_ERROR:
            state = {
                ...state,
                status: ApiStatusEnum.Error,
                error: action.payload,
            }
            break;
            
        case actions.API_RESET:
            state = {
                ...INITIAL_STATE
            }
            break;
              
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default ApiData;